import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterControls = ({ timeRange, setTimeRange, severityFilter, setSeverityFilter }) => {
  const timeRanges = [
    { value: '1h', label: '1 Hour' },
    { value: '6h', label: '6 Hours' },
    { value: '24h', label: '24 Hours' },
    { value: '7d', label: '7 Days' },
    { value: '30d', label: '30 Days' }
  ];

  const severityOptions = [
    { value: 'all', label: 'All Severities', color: 'gray' },
    { value: 'critical', label: 'Critical', color: 'red' },
    { value: 'warning', label: 'Warning', color: 'yellow' }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-4 mb-6">
      <div className="flex flex-col sm:flex-row gap-4">
        {/* Time Range Filter */}
        <div className="flex-1">
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            <Icon name="Clock" size={16} strokeWidth={2} className="inline mr-1" />
            Time Range
          </label>
          <div className="flex gap-2 flex-wrap">
            {timeRanges?.map((range) => (
              <button
                key={range?.value}
                onClick={() => setTimeRange(range?.value)}
                className={`px-4 py-2 rounded-lg border transition-colors ${
                  timeRange === range?.value
                    ? 'bg-blue-600 text-white border-blue-600' :'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                }`}
              >
                {range?.label}
              </button>
            ))}
          </div>
        </div>

        {/* Severity Filter */}
        <div className="flex-1">
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            <Icon name="Filter" size={16} strokeWidth={2} className="inline mr-1" />
            Severity Level
          </label>
          <div className="flex gap-2 flex-wrap">
            {severityOptions?.map((option) => (
              <button
                key={option?.value}
                onClick={() => setSeverityFilter(option?.value)}
                className={`px-4 py-2 rounded-lg border transition-colors ${
                  severityFilter === option?.value
                    ? option?.color === 'red' ?'bg-red-600 text-white border-red-600'
                      : option?.color === 'yellow' ?'bg-yellow-600 text-white border-yellow-600' :'bg-gray-600 text-white border-gray-600' :'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                }`}
              >
                {option?.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;